import { AfterViewInit, Component, ElementRef, inject, Input, ViewChild } from '@angular/core';
import { BaryModalEvent, IBaryModalEvent } from '../../../../../../models/bary-modal-event';
import { BaryComponentHelper } from '../../../../util/bary-component-helper';
import { MDBModalRef } from 'ng-uikit-pro-standard';
import { debounceTime } from 'rxjs/operators';
import { Transport } from '../../../../../../models/transport.model';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { Subject } from 'rxjs';
import { EstimateService } from '../../../../../../services/estimate.service';
import { TransportExtendedService } from '../../../../../../services/transport-extended.service';
import { mapAsBody } from '../../../../util/request-util';
import { OfferEstimation } from '../../../../../../models/offer-estimation.model';
import { OfferType } from '../../../../../../models/enums/offer-type.enum';
import { BaryPricingPackComponent } from '../../../../../+estimation';
import { TranslateDirective } from '../../../../../../directives/translate.directive';
import { NgForOf, NgIf } from '@angular/common';

@Component({
  selector: 'jhi-modal-change-offer',
  templateUrl: './modal-change-offer.component.html',
  styleUrls: ['./modal-change-offer.component.scss'],
  standalone: true,
  imports: [NgxSpinnerModule, BaryPricingPackComponent, TranslateDirective, NgIf, NgForOf],
})
export class ModalChangeOfferComponent implements AfterViewInit {
  #modalRef = inject(MDBModalRef);
  #transportService = inject(TransportExtendedService);
  #spinnerService = inject(NgxSpinnerService);
  #estimateService = inject(EstimateService);

  offerEstimations: OfferEstimation[] = [];

  @ViewChild('card') card!: ElementRef;

  @Input() transport!: Transport;
  action = BaryComponentHelper.generateAction<IBaryModalEvent>();
  loadingData = false;
  spinnerPriceName = 'priceRefreshing';

  private debouncerRefreshPrice: Subject<string> = new Subject<string>();

  constructor() {
    this.debouncerRefreshPrice.pipe(debounceTime(400)).subscribe(() => {
      this.refreshOffer();
    });
  }

  public handleClick(from: any): void {
    this.action.next(new BaryModalEvent(from));
    this.#modalRef.hide();
  }

  private refreshOffer(): void {
    this.loadingData = true;
    this.#spinnerService.show(this.spinnerPriceName).then();
    this.#estimateService
      .estimatePricing(this.transport)
      .pipe(mapAsBody)
      .subscribe(offerEstimations => {
        this.offerEstimations = (offerEstimations || []).filter(offer => offer.type !== OfferType.WITHOUT_CONSTRAINTS && offer.id !== this.transport.offerId);
      })
      .add(() =>
        this.#spinnerService.hide(this.spinnerPriceName).then(() => {
          this.loadingData = false;
        })
      );
  }

  public chooseOffer(offer: OfferEstimation): void {
    this.#transportService.applyOffer(offer.id, this.transport).subscribe(transport => {
      this.#modalRef.hide();
      transport.itemsNature = '';
      transport.insuranceItem = undefined;
      transport.goodsValue = undefined;
      this.action.next(new BaryModalEvent({ submit: true, value: transport.serialize() }));
    });
  }

  public ngAfterViewInit(): void {
    this.refreshOffer();
  }
}
